import { render } from "./personalDetail.vue?vue&type=template&id=1cc43f93&scoped=true"
import script from "./personalDetail.vue?vue&type=script&lang=js"
export * from "./personalDetail.vue?vue&type=script&lang=js"

import "./personalDetail.vue?vue&type=style&index=0&id=1cc43f93&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1cc43f93"

export default script